module.exports = __webpack_public_path__ + "static/media/logo-gray-scale.4c6b1b40.png";